"use client";

import Goftino from "@/src/components/common/service/online-chat/goftino/goftino";

const OnlineChatAlternative = () => {
    return (
        <>
            <Goftino/>
        </>
    );
}

export default OnlineChatAlternative;
